import { render, staticRenderFns } from "./extra-social-wall.vue?vue&type=template&id=0b55f4b5&lang=pug&"
import script from "./extra-social-wall.vue?vue&type=script&lang=js&"
export * from "./extra-social-wall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports